{
  "COMMON": {
    "ACTION_LABELS": {
      "SAVE": "Save"
    },
    "MANAGE_ATTRIBUTES": "Manage custom fields",
    "INVALID_DROPDOWN_ERROR": "Select a valid option",
    "ADD_FIELD": "Add {{fieldName}}..."
  },
  "AUXILIARY_DATA_TABLE": {
    "ATTRIBUTE_COLUMN": "Custom field",
    "DATA_COLUMN": "Data on file",
    "EMPTY": {
      "TITLE": "Leverage custom data in your workflow",
      "TEXT": "Quickly and easily collect data based on custom fields within the system and improve your data collection, storage, and reporting capabilities.",
      "BUTTON": "Set up custom fields"
    },
    "ERROR": {
      "TITLE": "Something went wrong",
      "TEXT": "Please wait a few moments and try again. If the problem persists, please contact an administrator"
    },
    "STRING_LIMIT_HINT": "{{characters}} characters (maximum 4000 characters)",
    "DELETED_ACCOUNT": "This account was recently deleted, and its custom data is still being processed."
  },
  "AUXILIARY_DATA_CARD": {
    "CARD_TITLE": "Custom fields",
    "SAVE": {
      "SUCESS": "Custom fields saved successfully",
      "ERROR": "Something went wrong"
    },
    "ERROR": {
      "TITLE": "Something went wrong",
      "TEXT": "Please wait a few moments and try again. If the problem persists, please contact an administrator"
    }
  },
  "AUXILIARY_DATA_PANEL": {
    "PANEL_TITLE": "Custom fields",
    "PANEL_DESCRIPTION": "Custom fields for the account",
    "ERROR": {
      "TITLE": "Something went wrong",
      "TEXT": "Please wait a few moments and try again. If the problem persists, please contact an administrator"
    }
  }
}
